<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div style="float: right">
        <md-button class="md-success" :disabled="isDisabled" @click="syncPricing()">Sync Stripe Price</md-button>
      </div>
      <tabs :tab-name="[ 'Subscriptions', 'One Time']" color-button="warning">
        <template slot="tab-pane-1">
            <md-card>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <md-table v-if="recurringPriceList.length > 0 " v-model="recurringPriceList" table-header-color="green">
                                <md-table-row slot="md-table-row" slot-scope="{ item }">            
                                    <md-table-cell md-label="Amount"> <b>{{ item.currency }} {{ item.amount }} / <small>{{ item.interval }}</small></b></md-table-cell>
                                    <md-table-cell md-label="Name">{{ item.name }} <br> <small>{{ item.priceId }}</small></md-table-cell>
                                    <md-table-cell md-label="Status">
                                        <p class="badge-success" v-if="item.status == 'Active'">Active</p>
                                        <p class="badge-danger" v-else>InActive</p>
                                    </md-table-cell>
                                    <md-table-cell md-label="Created On">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>
                                    <md-table-cell md-label="Actions">
                                        <md-button class="md-just-icon md-success md-simple" @click="$router.push({ path: 'admin-pricing-edit', query: { id: item._id }})"><md-icon>edit</md-icon></md-button>
                                        <md-button class="md-just-icon md-info md-simple" @click="openAndriodVersionCodeModal(item.name, item.identifier)"><md-icon title="Configure App Version">smartphone</md-icon></md-button>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                            <h4 v-else>No data found.</h4>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </template>
        <template slot="tab-pane-2">
            <md-card>
                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-100">
                            <md-table v-if="oneTimePriceList.length > 0 " v-model="oneTimePriceList" table-header-color="green">
                                <md-table-row slot="md-table-row" slot-scope="{ item }">            
                                    <md-table-cell md-label="Amount"> <b>{{ item.currency }} {{ item.amount }} </b></md-table-cell>
                                    <md-table-cell md-label="Name">{{ item.name }} <br> <small>{{ item.priceId }}</small></md-table-cell>
                                    <md-table-cell md-label="Status">
                                        <p class="badge-success" v-if="item.status == 'Active'">Active</p>
                                        <p class="badge-danger" v-else>InActive</p>
                                    </md-table-cell>
                                    <md-table-cell md-label="Created On">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>
                                    <md-table-cell md-label="Actions">
                                        <md-button class="md-just-icon md-success md-simple" @click="$router.push({ path: 'admin-pricing-edit', query: { id: item._id }})"><md-icon>edit</md-icon></md-button>
                                        <md-button class="md-just-icon md-info md-simple" @click="openAndriodVersionCodeModal(item.name, item.identifier)"><md-icon title="Configure App Version">smartphone</md-icon></md-button>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                            <h4 v-else>No data found.</h4>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </template>
      </tabs>
      <!-- Configure Andriod Version Code Modal -->
      <template>
          <modal v-if="andriodVersioncodeModal" @close="andriodVersioncodeModal = false">
            <template slot="header">
              <h4 class="modal-title">Configure {{ planName }}</h4>
              <md-button
                style="height: 25px" class="md-simple md-just-icon md-round modal-default-button"
                @click="andriodVersioncodeModal = false"><md-icon>clear</md-icon></md-button>
            </template>
            <template slot="body">
              <div class="box-body">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Min Version Code</label>
                      <md-input type="text" v-model="minAppVersionCode"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Message</label>
                      <md-input type="text" v-model="message"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-100">
                    <md-switch v-model="forceUpdate">Force Update</md-switch>
                  </div>
                </div>
              </div>
            </template>
            <template slot="footer">
              <md-button class="md-danger md-simple" @click="andriodVersioncodeModal = false">Close</md-button>
              <md-button class="md-success" :disabled="isDisabled" @click="updateAppVersion()">Save</md-button>
            </template>
          </modal>
      </template>
    </div>
  </div>
</template>
<script>
import PriceDataService from "../../../services/SuperAdmin/PriceDataService";
import { Tabs } from "@/components";
import { Modal } from "@/components";

export default {
  components: {
    Tabs,
    Modal,
  },
  data() {
    return {
      isDisabled: false,
      tableData: [],
      oneTimePriceList: [],
      recurringPriceList: [],

      andriodVersioncodeModal: false,
      minAppVersionCode: 0,
      message:"",
      forceUpdate: false,
      planName: "",
      planIdentifier: "",
    };
  },
  methods: {
      syncPricing() {
        this.isDisabled = true;
        PriceDataService.syncPricing()
          .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.listPrice();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
      },
      listPrice() {
        PriceDataService.listPrice()
          .then((response) => {
            this.recurringPriceList = response.data.data.recurringPriceList;
            this.oneTimePriceList = response.data.data.oneTimePriceList;
            this.$toast.success(response.data.respones_msg);
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
      },
      openAndriodVersionCodeModal(planName, planIdentifier) {
        this.minAppVersionCode =  "";
        this.message = "";
        this.forceUpdate = false;
        this.planName = planName;
        this.planIdentifier = planIdentifier;
        this.andriodVersioncodeModal = true;
        PriceDataService.getAppVersionDetail({ planIdentifier: planIdentifier })
          .then((response) => {
            if (response.data.data) {
              this.minAppVersionCode = response.data.data.minAppVersionCode;
              this.message = response.data.data.message;
              this.forceUpdate = response.data.data.forceUpdate;
            }
            this.$toast.success(response.data.respones_msg);
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });  
      },
      updateAppVersion() {
        let data =  {
          planIdentifier: this.planIdentifier,
          minAppVersionCode: this.minAppVersionCode,
          message: this.message,
          forceUpdate: this.forceUpdate
        }
        PriceDataService.updateAppVersion(data)
          .then((response) => {
            this.andriodVersioncodeModal = false;
            this.minAppVersionCode =  "";
            this.message = "";
            this.forceUpdate = false;
            this.$toast.success(response.data.respones_msg);
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          }); 
      }
  },
  beforeMount() {
    this.listPrice();
  },
};
</script>

<style>
@import '../../../assets/css/common.css';
</style>
